import { APP_VERSION } from '../js/utils/version.js';

export const DE = {
    // ===== MENU =====
    'menu.title': 'ARCHIV DES VERGESSENS',
    'menu.subtitle': 'Der Mneme-Bund',
    'menu.newGame': 'Neues Spiel',
    'menu.continue': 'Weiter',
    'menu.options': 'Optionen',
    'menu.quit': 'Beenden',
    'menu.version': `Version ${APP_VERSION} – AAA Overhaul`,

    // ===== OPTIONS =====
    'options.title': 'Spieleinstellungen',
    'options.language': 'Sprache / Language',
    'options.lang_de': 'Deutsch 🇩🇪',
    'options.lang_en': 'English 🇬🇧',
    'options.audio': 'Audio & Sound',
    'options.particles': 'Partikeleffekte',
    'options.floatingText': 'Schadenszahlen',
    'options.cloudSync': 'Cloud-Synchronisation',
    'options.autosave': 'Automatisches Speichern',
    'options.deleteSave': 'Spielstand zurücksetzen',
    'options.close': 'Schließen',
    'options.enabled': 'Aktiviert',
    'options.disabled': 'Deaktiviert',

    // ===== HUB / NAVIGATION =====
    'hub.hero': 'Held',
    'hub.quests': 'Quests',
    'hub.forge': 'Schmiede',
    'hub.crafting': 'Handwerk',
    'hub.skilltree': 'Talente',
    'hub.codex': 'Kodex',
    'hub.clan': 'Clan',
    'hub.guild': 'Gilde',
    'hub.friends': 'Freunde',
    'hub.leaderboard': 'Bestenliste',
    'hub.story': 'Chronik',
    'hub.relicHunt': 'Reliktjagd',
    'hub.chat': 'Chat',

    // ===== HERO =====
    'hero.title': 'Der Hüter der Mneme',
    'hero.level': 'Stufe',
    'hero.xp': 'Erfahrung',
    'hero.hp': 'Lebenspunkte',
    'hero.atk': 'Angriff',
    'hero.def': 'Verteidigung',
    'hero.crit': 'Kritischer Treffer',
    'hero.prestige': 'Verewigung',
    'hero.inventory': 'Inventar',
    'hero.equipment': 'Ausrüstung',
    'hero.stats': 'Attribute',

    // ===== AUTH & ACCOUNT =====
    'auth.title': 'BENUTZERKONTO',
    'auth.login': 'Anmelden',
    'auth.register': 'Registrieren',
    'auth.logout': 'Abmelden',
    'auth.guest': 'Gast-Modus',
    'auth.username': 'Benutzername',
    'auth.email': 'E-Mail-Adresse',
    'auth.password': 'Passwort',
    'auth.guestBadge': 'Gast-Hüter',
    'auth.loggedInAs': 'Angemeldet als',
    'auth.upgradeGuest': 'Konto jetzt registrieren',
    'auth.accountDetails': 'Konto-Details',
    'auth.created': 'Mitglied seit',
    'auth.syncStatus': 'Cloud-Synchronisation',
    'auth.error.missing_fields': 'Bitte fülle alle erforderlichen Felder aus.',
    'auth.error.user_not_found': 'Benutzer oder E-Mail wurde nicht gefunden.',
    'auth.error.wrong_password': 'Das eingegebene Passwort ist falsch.',
    'auth.error.username_short': 'Benutzername muss mindestens 3 Zeichen lang sein.',
    'auth.error.email_invalid': 'Bitte gib eine gültige E-Mail-Adresse ein.',
    'auth.error.password_short': 'Das Passwort muss mindestens 6 Zeichen lang sein.',
    'auth.error.username_taken': 'Dieser Benutzername ist bereits vergeben.',
    'auth.error.email_taken': 'Diese E-Mail-Adresse wird bereits verwendet.',
    'auth.error.server_timeout': 'Zeitüberschreitung bei der Serververbindung.',
    'auth.error.not_guest': 'Konto ist kein Gast-Konto.',
    'auth.error.server_error': 'Serverfehler aufgetreten. Bitte versuche es später erneut.',
    'auth.success.registered': 'Konto erfolgreich erstellt!',
    'auth.success.registeredPopup': 'Dein Konto wurde erfolgreich erstellt! Du wirst jetzt zum Login weitergeleitet.',
    'auth.success.registeredTitle': 'REGISTRIERUNG ERFOLGREICH',
    'auth.success.login': 'Willkommen zurück, Hüter!',
    'auth.success.guestConverted': 'Gast-Konto erfolgreich umgewandelt!',

    // ===== UI & ACTION KEYS =====
    'ui.bulk_salvage': 'Massen-Verwertung',
    'ui.salvage_all': 'Alle gewöhnlichen verwerten',
    'ui.confirm_salvage': 'Möchtest du diese Gegenstände wirklich verwerten?',

    // ===== COMMON =====
    'common.confirm': 'Bestätigen',
    'common.cancel': 'Abbrechen',
    'common.close': 'Schließen',
    'common.back': 'Zurück',
    'common.save': 'Speichern',
    'common.success': 'Erfolg!',
    'common.error': 'Fehler!',
    'common.loading': 'Lade Daten...'
};

